import * as angular from 'angular';
import { IApprovalStrategy } from '../../models/ApprovalStrategy';
import { IRequestService } from '../request.service';
import { GroupNameDto } from '../../models';

export interface IApprovalStrategyService {
    getAll(): angular.IPromise<IApprovalStrategy[]>;
    getAll(force: boolean): angular.IPromise<IApprovalStrategy[]>;
    getGroups(): angular.IPromise<{ [index: string]: GroupNameDto[] }>;
    addStrategy(strategy: IApprovalStrategy): angular.IPromise<IApprovalStrategy>;
    update(strategy: IApprovalStrategy): angular.IPromise<IApprovalStrategy>;
    deleteStrategy(guid: string): angular.IPromise<void>;
}

export class ApprovalStrategyService implements IApprovalStrategyService {

    static serviceId = 'approvalStrategyService';
    static $inject = ['requestService'];

    constructor(private _requestService: IRequestService) {

    }

    getAll(force?: boolean): angular.IPromise<IApprovalStrategy[]> {
        const url = 'approvalStrategy/';
        if (force) {
            this._requestService.cleanCacheAtV1(url);
        }
        return this._requestService.getAtV1(url);
    }

    getGroups(): angular.IPromise<{ [index: string]: GroupNameDto[] }> {
        return this._requestService.getAtV1('approvalStrategy/getGroups');

    }

    addStrategy(strategy: IApprovalStrategy): angular.IPromise<IApprovalStrategy> {
        return this._requestService.postAtV1<IApprovalStrategy>('approvalStrategy/add', strategy)
            .then((data) => {
                this._requestService.cleanCacheAtV1('approvalStrategy/');
                return data;
            });
    }
    update(strategy: IApprovalStrategy): angular.IPromise<IApprovalStrategy> {
        return this._requestService.postAtV1<IApprovalStrategy>('approvalStrategy/', strategy)
            .then(data => {
                this._requestService.cleanAllCache();
                return data;
            });
    }

    deleteStrategy(guid: string): angular.IPromise<void> {
        return this._requestService.deleteAtV1('approvalStrategy/delete/' + guid)
            .then(data => {
                this._requestService.cleanCacheAtV1('approvalStrategy/');
                return data;
            });
    }
}